import { Promotion, PromotionStatus } from '@esportal/portal-service';

export const getPromotionByName = (promotions: [Promotion], name: string): Promotion | undefined => {
	return promotions.find((promotion) => promotion.name === name);
};

export const isPromotionOpened = (promotion: Promotion): boolean => {
	return promotion.status == PromotionStatus.OPEN && !promotion.contestant;
};

export const personParticipatedInPromotion = (promotion: Promotion): boolean => {
	return promotion.contestant?.status == 'ENROLLED';
};

export const isPersonNotWinnerInPromotion = (promotion: Promotion): boolean => {
	return promotion.contestant?.status == 'NOT WINNER';
};
